import { classNames } from '@axo/shared/util/dom';
import { Classes, Overlay2 } from '@blueprintjs/core';

import styles from './Modal.module.css';

type ModalProps = {
  children?: React.ReactNode;
  onClose?: () => void;
  title?: string | React.ReactNode;
};
export const Modal = ({ children, onClose, title }: ModalProps) => {
  return (
    <Overlay2
      isOpen={true}
      onClose={onClose}
      className={Classes.OVERLAY_CONTENT}
    >
      <div className={classNames(styles.modal)}>
        {title && <div className={styles.modal__title}>{title}</div>}
        <div className={styles.modal__content}>{children}</div>
      </div>
    </Overlay2>
  );
};
